import QueryResults from "./QueryResults";

export default class QueryResults_Apparecchi extends QueryResults {
  constructor(qb, collectionName, target, resultsProvider, callback, additionalFields) {
    super(qb, collectionName, target, resultsProvider, callback, additionalFields);
  }

  getColumns() {
    let columnDefs = [
      // Filmografia
      this.fr.fieldFilmografia(),
      // Apri scheda
      this.fr.fieldCta(this.collectionName, this.dispatch.bind(this)),
      // Media (immagine)
      {
        field: "media",
        headerName: this.fr.getLabel("media", "Media"),
        autoHeight: true,
        wrapText: true, // Abilita il wrapping del testo nella cella
        sortable: false, // Disabilita l'ordinamento
        cellRenderer: (params) => {
          const a = this.fr.getField(params.value);
          if (a.length > 0) {
            const entry = a[0];
            // Crea un contenitore div e l'immagine
            const container = document.createElement("div");
            container.classList.add("grid-media-container");
            const img = document.createElement("img");
            img.src = entry.preview_url;
            // ███    ██  ██████  ████████  █████       ██████  ██  ██████   █████  ███    ██ ████████ ███████
            // ████   ██ ██    ██    ██    ██   ██     ██       ██ ██       ██   ██ ████   ██    ██    ██
            // ██ ██  ██ ██    ██    ██    ███████     ██   ███ ██ ██   ███ ███████ ██ ██  ██    ██    █████
            // ██  ██ ██ ██    ██    ██    ██   ██     ██    ██ ██ ██    ██ ██   ██ ██  ██ ██    ██    ██
            // ██   ████  ██████     ██    ██   ██      ██████  ██  ██████  ██   ██ ██   ████    ██    ███████
            // Qui c'è una forzatura da paura per visualizzare il player video che ovviamente sarà da rimuovere
            img.onclick = () => {
              if (params.data.object_id !== 335982) {
                this.fr.openSwiperCarousel(a); // Chiama il metodo per aprire il carousel
              } else {
                this.fr.openPlayer();
              }
            };

            if (params.data.object_id !== 335982) {
              // Aggiunge un numerino che indica il numero di immagini
              if (a.length > 1) {
                const badge = document.createElement("div");
                badge.classList.add("badge-item-counter");
                badge.textContent = a.length;
                container.appendChild(badge);
              }
            }
            container.appendChild(img);
            return container;
          }
          return "";
        },
        flex: 2,
      },

      // NCNT
      this.fr.fieldList("numero_catalogo_generale_NCTN", "NCNT", 1, this.dispatch.bind(this), "APPARECCHI_numero_catalogo_generale_NCTN"),
      // RVEL
      this.fr.fieldPlain("livello_RVEL", "Livello", 1),
      // Definizione
      this.fr.fieldPlain("definizione_oggetto_OGTD", "Definizione", 2),
      // Inventario
      this.fr.fieldList("inventario_INV", "Inventario", 2, null, null, ["denominazione_INVA", "numero_INVN"], "<br>"),
      // Oggetto
      this.fr.fieldList("definizione_oggetto_OGTD", "Oggetto", 2, this.dispatch.bind(this), "APPARECCHI_definizione_oggetto_OGTD"),
      // Tipologia
      this.fr.fieldList("tipologia_OGTT", "Tipologia", 2, this.dispatch.bind(this), "APPARECCHI_tipologia_OGTT"),
      // Titolo/modello
      this.fr.fieldPlain("label", "Titolo/modello", 2),
      // Soggetto
      this.fr.fieldList("identificazione_soggetto_SGTI", "Soggetto", 2, this.dispatch.bind(this), "APPARECCHI_identificazione_soggetto_SGTI"),
      // Autori
      this.fr.fieldList("entities", "Autori", 2, this.dispatch.bind(this), "APPARECCHI_autore", "label", "<br>", "relation_type_code", "mnc_978", null, { type: QueryResults.SCHEDA_TYPE_ENITITA, prop: "entities.rel_entity_id", key: "rel_entity_id" }),
      // Acquisizione
      this.fr.fieldMultiple("tipo_acquisizione_ACQT", "Acquisizioni", 2, ["tipo_acquisizione_ACQT", "data_acquisizione_ACQD", "luogo_acquisizione_ACQL", "nome_ACQN"], "<br>"),
      // Cronologia
      this.fr.fieldList("nuova_cronologia", "Cronologia", 2, null, null, ["cronologia", "da_frazione_secolo", "da_secolo", "a_frazione_secolo", "a_secolo"], "<br>", "cronologia", "generica (DTZ)"),
      // Collocazione
      this.fr.fieldMultiple("denominazione_raccolta_LDCM", "Collocazione", 2, ["denominazione_raccolta_LDCM", "denominazione_LDCN", "specifiche_LDCS"], "<br>"),
      // Object ID
      this.fr.fieldPlain("object_id", "ID", 1),
    ];

    columnDefs = this.addAdditionalFields(columnDefs);
    this.columnDefs = columnDefs;
    return columnDefs;
  }

  onRowClicked(event) {
    console.log("Row fototeca clicked", event);
  }
}

QueryResults_Apparecchi.QUERY_numero_catalogo_generale_NCTN = {
  id: "QN1731012243823",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731012243825",
      Field: {
        _path: "/numero_catalogo_generale_NCTN",
        _label: "/numero_catalogo_generale_NCTN",
        Name: "numero_catalogo_generale_NCTN",
        Label: "numero_catalogo_generale_NCTN",
        Relation: null,
        Flags: 7,
        IsArray: false,
        Type: "text",
      },
      Occurency: "MUST",
      type: "QueryNodeTerm",
      Value: "",
      Compare: "tPHRASEw",
    },
  ],
  CollectionName: "APPARECCHI_coll",
};

QueryResults_Apparecchi.QUERY_definizione_oggetto_OGTD = {
  id: "QN1731070428345",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731070428349",
      Field: {
        _path: "/definizione_oggetto_OGTD",
        _label: "/definizione_oggetto_OGTD",
        Name: "definizione_oggetto_OGTD",
        Label: "definizione_oggetto_OGTD",
        Relation: null,
        Flags: 7,
        IsArray: false,
        Type: "text",
      },
      Occurency: "MUST",
      type: "QueryNodeTerm",
      Value: "dummy",
      Compare: "tPHRASEw",
    },
  ],
  CollectionName: "APPARECCHI_coll",
};

QueryResults_Apparecchi.QUERY_tipologia_OGTT = {
  id: "QN1731070428345",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731070428350",
      Field: {
        _path: "/tipologia_OGTT",
        _label: "/tipologia_OGTT",
        Name: "tipologia_OGTT",
        Label: "tipologia_OGTT",
        Relation: null,
        Flags: 7,
        IsArray: false,
        Type: "text",
      },
      Occurency: "MUST",
      type: "QueryNodeTerm",
      Value: "dummy",
      Compare: "tPHRASEw",
    },
  ],
  CollectionName: "APPARECCHI_coll",
};

QueryResults_Apparecchi.QUERY_identificazione_soggetto_SGTI = {
  id: "QN1731071341105",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731071341106",
      Field: {
        _path: "/identificazione_soggetto_SGTI",
        _label: "/identificazione_soggetto_SGTI",
        Name: "identificazione_soggetto_SGTI",
        Label: "identificazione_soggetto_SGTI",
        Relation: null,
        Flags: 7,
        IsArray: true,
        Type: "text",
      },
      Occurency: "MUST",
      type: "QueryNodeTerm",
      Value: "dummy",
      Compare: "tPHRASEw",
    },
  ],
  CollectionName: "APPARECCHI_coll",
};

QueryResults_Apparecchi.QUERY_autore = {
  id: "QN1731071538213",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731071538225",
      Field: {
        _path: "/entities",
        _label: "/entities",
        Name: "entities",
        Label: "entities",
        Relation: null,
        Flags: 7,
        IsArray: true,
        Type: "complex",
      },
      Occurency: "MUST",
      type: "QueryNodeBoolean",
      AdmitExists: true,
      Operator: "AND",
      Clauses: [
        {
          id: "QN1731071538226",
          Field: {
            _path: "/entities/relation_type_code",
            _label: "/entities/relation_type_code",
            Name: "relation_type_code",
            Label: "relation_type_code",
            Relation: null,
            Flags: 7,
            IsArray: false,
            Type: "text",
            Lookup: "APPARECCHI_entities_relation_types",
          },
          Occurency: "MUST",
          type: "QueryNodeTerm",
          Value: "mnc_978",
          Compare: "sEQUALS",
        },
        {
          id: "QN1731071538228",
          Field: {
            _path: "/entities/label",
            _label: "/entities/label",
            Name: "label",
            Label: "label",
            Relation: null,
            Flags: 7,
            IsArray: false,
            Type: "text",
          },
          Occurency: "MUST",
          type: "QueryNodeTerm",
          Value: "dummy",
          Compare: "tPHRASEw",
        },
      ],
    },
  ],
  CollectionName: "APPARECCHI_coll",
};
